import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfv_J6 } from "../../../modules/Beräkningsmoduler/BFV_J6";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFV_J6 = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  const bm = bfv_J6().getResult(module, bimHandler, roundHandler, global.data as IGlobalData);

  const funktionsKontroller = bm.funktionsKontroller;

  return (
    <div>
      BFV J6: ...Synlig endast via integration till J5
      <Funktionskontroller bfName="BFV_J6" formHook={formHook} funktionsKontroller={funktionsKontroller} />
      <BFLNote formHook={formHook} />
      <ErrorInfo info={bm.error} />
      <DebugInfo info={bm.debug} />
    </div>
  );
};

export default BFV_J6;
